<template>
    <div style="display: flex;justify-content: center;">
        <div style="background-color: #fff;padding: 1rem;border-radius: 10px;">
            <div v-if="buying" style="margin-top: 30px;">
                <div style="display: flex;justify-content:center;flex-wrap: wrap;">
                    <div
                        style="display: flex;flex-direction: column;justify-content: center;width: 50%;min-width: 300px;">
                        <div style="text-align: center;">用户{{ username }}</div>
                        <div style="text-align: center;">购买{{ vip_check.name }}</div>
                        <div style="display: flex;justify-content: center;width: 100%;margin-top: 20px;">

                            <div id="qrcode" ref="qrcode"></div>

                        </div>
                        <div style="display: flex;justify-content: center;align-items: center;margin: 10px 0px;">

                            <el-image style="width: 22px;height: 22px;" :src="require('@/assets/img/alipay.png')">
                            </el-image>
                            <div>使用支付宝扫码付款</div>
                        </div>
                        <div style="text-align: center;font-size: 22px;">￥{{ buying.pay }}元</div>
                        <div style="display: flex;justify-content: center;">
                            <el-button style="margin-top: 20px;width: 100px;" type="info"
                                @click="buy_out">取消</el-button>
                            <el-button style="margin-top: 20px;width: 100px;" type="primary"
                                @click="buy_ok">已付款</el-button>
                        </div>
                    </div>
                </div>
            </div>

            <div v-else style="margin-top: 20px;">
                <el-page-header @back="goBack" content="购买会员">
                </el-page-header>

                <div class="xz" style="margin-top: 30px;">
                    <el-radio-group v-model="buy_type" size="medium" @change="buy_type_fc">
                        <el-radio-button label="体验卡"></el-radio-button>
                        <el-radio-button label="月卡套餐"></el-radio-button>
                        <el-radio-button label="点数套餐"></el-radio-button>
                    </el-radio-group>

                </div>
                <div style="display: flex;margin-top: 30px;">
                    <el-input size="medium" placeholder="填写充值用户名/手机号" clearable v-model="username"></el-input>
                    <el-button size="medium" type="primary"
                        style="margin-left: 5px;background-color: #3239a9;border: 0;width: 140px;"
                        @click="buy(vip_check)">
                        立即购买
                    </el-button>
                </div>

                <el-row :gutter="20" style="padding: 20px 0;">
                    <el-col :xs="24" :sm="12" :md="12" :xl="8" v-for="(item, index) in vip_list" :key="index"
                        style="padding: 4px 5px;">
                        <div @click="vip_check = item"
                            style="background-color: #f5f5f5;position: relative;border-radius: 10px;padding: 10px 15px;border: 1px solid #f5f5f5;cursor: pointer;"
                            :style="vip_check.id == item.id ? 'background-color:#3239a915;border: 1px solid #3239a9;' : ''">
                            <div v-if="index == 2 && item.type == 1 || index == 1 && item.type == 2"
                                style="position: absolute;top:0;right: 0;background-color: rgb(237 96 96);padding: 3px 7px;color: #fff;border-radius: 0px 10px 0px 10px;font-size: 12px;">
                                热销</div>
                            <div style="display: flex;align-items: center;">
                                <el-image v-if="index == 0" style="width: 25px;"
                                    :src="require('@/assets/vip/hg3.png')"></el-image>
                                <el-image v-else-if="index == 1" style="width: 25px;"
                                    :src="require('@/assets/vip/hg2.png')">
                                </el-image>
                                <el-image v-else-if="index == 2" style="width: 25px;"
                                    :src="require('@/assets/vip/hg1.png')">
                                </el-image>
                                <div style="font-size: 14px;margin-left: 5px;">{{ item.name }} {{ item.hz == 1 ? '1080p'
                                    :
                                    '720p' }}
                                </div>
                            </div>

                            <!-- 价格换算 -->
                            <div style="display: flex;">
                                <div style="margin-top:10px;font-size: 29px;display: flex;justify-content: center;"
                                    v-if="item.type == 3">
                                    {{ item.surplus }}
                                    <div style="font-size: 12px;margin-top: 15px;margin-left: 3px;color: #999;">/点</div>
                                </div>
                                <div v-else-if="item.type == 2"
                                    style="margin-top:10px;font-size: 29px;display: flex;color: #393939;">
                                    <div style="font-size: 14px;margin-top: 14px;">
                                        ￥
                                    </div>
                                    {{ item.pay }}
                                    <div style="font-size: 12px;margin-top: 15px;margin-left: 3px;color: #494949;">
                                        /月(30天)
                                    </div>
                                </div>
                                <div style="margin-top:10px;font-size: 29px;display: flex;justify-content: center;color: #393939;"
                                    v-else>
                                    <div style="font-size: 14px;margin-top: 14px;">
                                        ￥
                                    </div>
                                    {{ item.pay }}
                                    <div style="font-size: 12px;margin-top: 15px;margin-left: 3px;color: #494949;">/{{
                                        item.surplus
                                    }}点
                                    </div>
                                </div>
                                <div
                                    style="font-size: 12px;display: flex;color: #888;text-decoration:line-through;margin-left: 10px;align-items: end;margin-bottom: 7px;">
                                    原价{{ item.pay + 48 }}元
                                </div>
                            </div>

                            <!-- 简介区 -->
                            <div style="font-size: 12px;margin-top: 10px;color: #393939;" v-if="item.type == 2">
                                每日可用{{ item.today }}点</div>
                            <div style="font-size: 12px;margin-top: 10px;color: #666;" v-else>有效期一年(365天)</div>
                        </div>
                    </el-col>
                </el-row>

            </div>
            <!-- <div style="width: 100%;display: flex;justify-content:center;margin-top: 30px;" v-if="!buying">

            <el-button style="width: 140px;background-color: #3239a9;border: 0;" type="primary" @click="buy(vip_check)"
                icon="el-icon-s-finance">立即购买</el-button>

        </div> -->
            <div style="margin-top: 30px;">
                <div style="margin-top: 20px;font-size: 12px;"> <i class="el-icon-info">
                    </i> 本服务属于特殊商品购买后不支持退款！</div>
                <div style="font-size: 12px;margin-top: 10px;" v-if="buying.type != 3">
                    <i class="el-icon-info"></i> 计费方式: 单个视频每2分钟1点
                </div>
            </div>

            <div style="justify-content: center;flex-wrap: wrap;margin-top: 10px;font-size: 12px;">
                <i class="el-icon-info"></i> 订阅{{ $siteConfig.siteName }}服务，即表示您同意我们的
                <el-link type="primary" @click="sytk = true" style="font-size: 12px;">《商业服务条款》</el-link> 和 <el-link
                    type="primary" @click="yszc = true" style="font-size: 12px;">
                    《隐私协议》</el-link>
            </div>

            <el-dialog title="《商业服务条款》" :visible.sync="sytk" append-to-body custom-class="newdialog_share">
                <div style="height: 500px;">
                    <iframe src="../../../static/sytk.html" frameborder="0" style="width: 100%;height: 100%;"></iframe>
                </div>
            </el-dialog>
            <el-dialog title="《隐私协议》" :visible.sync="yszc" append-to-body custom-class="newdialog_share">
                <div style="height: 500px;">
                    <iframe src="../../../static/yszc.html" frameborder="0" style="width: 100%;height: 100%;"></iframe>
                </div>
            </el-dialog>
        </div>
    </div>
</template>

<script>
// 这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
import QRCode from 'qrcodejs2'
export default {
    name: '',
    components: {

    },
    // 定义属性
    data() {
        return {
            vip_list: [],
            buy_type: '月卡套餐',
            buying: false,
            ordernum: '',
            sytk: false,
            yszc: false,
            user_balance: 0,
            vip_check: [],
            username: ''
        }
    },
    // 计算属性，会监听依赖属性值随之变化
    computed: {},
    // 监控data中的数据变化
    watch: {},
    // 方法集合
    methods: {
        goBack() {
            if (window.history.length > 1) {
                this.$router.go(-1)
            } else {
                this.$router.replace('/') // 无历史则替换到首页
            }
        },
        cz_order() {
            this.$parent.$parent.$parent.vip = false
            this.$router.push('/user/info')

        },
        buy(item) {
            if (!this.username) {
                this.$toast.show("请输入用户名", 2000);
                return
            }
            this.buy_ma(item)
        },
        buy_ma(item) {
            const loading = this.$loading(this.$loadinginfo);
            var data = item
            data['username'] = this.username
            this.$ajax.post('qhy/user/payFace', data, { headers: { 'Content-Type': 'application/x-www-form-urlencoded' } }).then(res => {
                console.log(res.data)
                var jg = res.data
                if (res.data.status == 200) {
                    this.buying = item
                    this.ordernum = jg.ordernum

                    // alert(navigator.userAgent);

                    if (~navigator.userAgent.indexOf('Mobile')) {
                        window.location.href = jg.url;
                    }
                    this.$nextTick(() => {
                        this.qrcode(jg.url)
                    })

                } else {
                    // this.$msg.error(res.data.msg)
                    this.$toast.show(res.data.msg, 3000);
                }
                loading.close();
            })
        },
        buy_ok() {
            var data = { ordernum: this.ordernum }
            this.$ajax.post('qhy/user/payok', data, { headers: { 'Content-Type': 'application/x-www-form-urlencoded' } }).then(res => {
                // console.log(res.data)
                // var jg = res.data
                if (res.data.status == 200) {
                    // this.$msg.success(res.data.msg)
                    this.$alert(res.data.msg, '提示', {
                        confirmButtonText: '确定',
                        type: 'success',
                        callback: action => {
                            this.buying = false
                            this.ordernum = ''
                            // this.$parent.$parent.$parent.vip = false
                        }
                    });

                } else {
                    this.$msg.error(res.data.msg)
                }

            })
        },
        buy_out() {
            this.buying = false
            this.ordernum = ''
        },
        qrcode(url) {
            // console.log(this.qrcode_m)
            if (this.qrcode_m) {
                this.qrcode_m.clear();

            }
            this.qrcode_m = new QRCode("qrcode", {

                width: 150, // 二维码宽度，单位像素

                height: 150, // 二维码高度，单位像素

                text: url // 生成二维码的链接

            });


        },

        buy_type_fc() {
            console.log(this.buy_type)
            this.vip_list_fc()
        },
        vip_list_fc(type = '') {
            const loading = this.$loading({
                lock: true,
                text: '努力加载中...',
                spinner: 'el-icon-loading',
                background: 'rgba(255, 255, 255, 0.9)',
                target: document.querySelector('.el-dialog__body')
            });
            if (type == '') {
                type = this.buy_type
            }
            var data = { 'type': type }
            this.$ajax.post('qhy/user/vip_open', data, { headers: { 'Content-Type': 'application/x-www-form-urlencoded' } }).then(res => {
                console.log(res.data)
                var jg = res.data
                if (res.data.status == 200) {
                    this.vip_list = jg.data
                    this.vip_check = this.vip_list[0]
                    this.user_balance = jg.balance
                    loading.close();
                }

            })
        }
    },
    // 生命周期 - 创建完成（可以访问当前this实例）
    created() {
        if (this.vip_list.length < 1) {
            this.vip_list_fc()
        }
    },
    // 生命周期 - 挂载完成（可以访问DOM元素）
    mounted() {
        // this.vip_list_fc()
    },
    beforeCreate() { }, // 生命周期 - 创建之前
    beforeMount() { }, // 生命周期 - 挂载之前
    beforeUpdate() { }, // 生命周期 - 更新之前
    updated() { }, // 生命周期 - 更新之后
    beforeDestroy() { }, // 生命周期 - 销毁之前
    destroyed() { }, // 生命周期 - 销毁完成
    activated() { }, // 如果页面有keep-alive缓存功能，这个函数会触发
}
</script>

<style>
.xz {
    display: flex;
    justify-content: center;
    align-items: center;
    flex-wrap: wrap;
}

.xz .el-radio-button__orig-radio:checked+.el-radio-button__inner {
    background-color: #1279e6;
    border-color: #1279e6;
    box-shadow: -1px 0 0 0 #1279e6;
}

.xz .el-radio-group {
    display: flex;
    justify-content: center;
    flex-wrap: wrap;
}

.xz .el-radio-button__inner {
    border-left: 1px solid #DCDFE6;
    margin: 5px 0px;
}

.xz .el-radio-button:last-child .el-radio-button__inner {
    border-radius: 0px;
}

.tc_item {
    border-radius: 10px;
    margin: 6px;
    width: 30%;
    min-width: 100%;
    position: relative;
    background-color: #f5f5f5;
    border: 0px;
    padding: 20px 0px;
}
</style>


// WEBPACK FOOTER //
// src/components/User/vip_open.vue


// WEBPACK FOOTER //
// src/components/User/vip_open.vue